export const upload = [
    { label: "Upload E-Wallet statement", value: "e-wallet", subOptions: ["Gopay", "Dana", "Ovo"] },
    { label: "Upload bank statement", value: "bank", subOptions: ["Bank BRI", "Bank BCA", "Bank Permata"] },
    { label: "Upload browsing history", value: "browsing", subOptions: ["Google chrome", "Brave browser", "Arc browser"] },
    { label: "Upload Shopping history", value: "shopping", subOptions: ["Amazon", "Jumia", "Ebay"] },
];